import React from "react";
import { Placeholder6 } from "../../../icons/Placeholder6";
import configs from "../../../contentConfig";

const selectionType = configs["fiterComponet"]?.["selection"] || "border"

export const Tab = ({
  state,
  className,
  icon = <Placeholder6 className="!relative !w-6 !h-6 !mt-[-5px]" />,
  text = "Text",
  divClassName,
  onClickHandler,
  data={}
}) => {
  const activeBorderStyle = selectionType === "border" && state === "active" ? { borderBottom: "3px solid #BC9962" } : {};

  return (
    <div
    onClick={(e)=>{
        onClickHandler(e,data)
    }}
      className={`!w-20 flex flex-col items-center gap-1 px-6 py-4 h-[80px] justify-between relative ${className} cursor-pointer box1`}
      style={{
        ...activeBorderStyle,
        width:"5rem"
      }}
    >
      <div className="tab-element-icons">
      {icon}
      </div>
      <div
        className={`font-secondary w-fit tracking-[-0.32px] text-sm text-black font-normal leading-[normal] relative ${divClassName} tab-element-name ${state==="active"?"active_tab":""}`}
      >
        {text}
      </div>
    </div>
  );
};
